import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./modalUmum.scss";
import { TiMessages } from "react-icons/ti";
import { AiOutlineClose } from "react-icons/ai";

function ModalUmum({ show, onHide, nextButton, title }) {
  return (
    <div
      id={show ? "show-modal" : "close-modal"}
      style={{
        width: "100vw",
        margin: "0",
        height: "100vh",
        position: "fixed",
      }}
    >
      <Modal.Dialog id="body-modalUmumContent">
        <Modal.Header onClick={onHide} id="header-body">
          <Modal.Title>
            <TiMessages color="#FFD700" fontSize="35px" /> AMO Message
          </Modal.Title>
          <AiOutlineClose color="white" fontSize="25px" onClick={onHide} />
        </Modal.Header>

        <Modal.Body>
          <p className="fw-bold fs-5">{title}</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="warning"
            onClick={nextButton}
            style={{ color: "black", width: "100%" }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
}

export default ModalUmum;
